var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tab-select',{staticClass:"c2-select-tab",attrs:{"items":_vm.availableTabs,"value":_vm.activeTab},on:{"input":function($event){return _vm.set({ stateProp: 'activeTab', value: $event.id })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }